document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-mobile-menu]');
  const drawer=document.querySelector('[data-mobile-drawer]');
  const closeButtons=document.querySelectorAll('[data-mobile-close]');
  const toggles=document.querySelectorAll('[data-menu-toggle]');

  if(b&&drawer){
    const setOpen=(open)=>{
      drawer.classList.toggle('is-open',open);
      drawer.setAttribute('aria-hidden',String(!open));
      b.setAttribute('aria-expanded',String(open));
      b.setAttribute('aria-label',open?'Close menu':'Open menu');
      document.body.classList.toggle('ov-menu-open',open);
    };
    b.addEventListener('click',()=>setOpen(!drawer.classList.contains('is-open')));
    closeButtons.forEach(closeButton=>closeButton.addEventListener('click',()=>setOpen(false)));
    drawer.querySelectorAll('a').forEach(a=>{
      a.addEventListener('click',()=>setOpen(false));
    });
    document.addEventListener('click',(e)=>{
      if(drawer.classList.contains('is-open')&&!drawer.contains(e.target)&&!b.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown',(e)=>{
      if(e.key==='Escape'&&drawer.classList.contains('is-open')) setOpen(false);
    });
    toggles.forEach(toggle=>{
      toggle.addEventListener('click',()=>{
        const submenu=toggle.nextElementSibling;
        const open=toggle.getAttribute('aria-expanded')==='true';
        toggle.setAttribute('aria-expanded',String(!open));
        if(submenu){
          submenu.classList.toggle('is-open',!open);
          submenu.setAttribute('aria-hidden',String(open));
        }
        const indicator=toggle.querySelector('span:last-child');
        if(indicator) indicator.textContent=open?'+':'−';
      });
    });
  }

  document.querySelectorAll('.ov-product-page').forEach((page)=>{
    const form=page.querySelector('form[action*="/cart/add"]');
    if(!form || form.dataset.purchaseUxReady==='true') return;
    form.dataset.purchaseUxReady='true';

    const variantData=document.querySelector('[data-product-variants]');
    let variants=[];
    try{ variants=JSON.parse(variantData?.textContent||'[]'); }catch(e){}
    const optionSelects=[...form.querySelectorAll('select[name^="options["]')];
    const idSelect=form.querySelector('select[name="id"]');
    const addButton=form.querySelector('[data-add-to-bag]');
    const sticky=page.querySelector('[data-sticky-buy]');
    const stickyAdd=page.querySelector('[data-sticky-add]');
    const stickyNow=page.querySelector('[data-sticky-buy-now]');
    const stickyPrice=page.querySelector('[data-sticky-price]');
    const buyNowButton=form.querySelector('.shopify-payment-button__button');
    const mainActions=page.querySelector('[data-purchase-actions]');

    function currentVariant(){
      if(!variants.length) return null;
      const values=optionSelects.map(s=>s.value);
      return variants.find(v=>v.options && v.options.every((value,i)=>value===values[i])) || null;
    }
    function money(cents){
      try{return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2}).format(cents/100)}catch(e){return '₹'+(cents/100).toFixed(2)}
    }
    function syncVariant(){
      const v=currentVariant();
      if(!v) return;
      if(idSelect) idSelect.value=String(v.id);
      const available=!!v.available;
      if(addButton){addButton.disabled=!available;addButton.textContent=available?'Add to bag':'Sold out';}
      if(stickyAdd) stickyAdd.disabled=!available;
      if(stickyNow) stickyNow.disabled=!available;
      if(stickyPrice) stickyPrice.textContent=money(v.price);
      if(available && window.history?.replaceState){
        const url=new URL(window.location.href); url.searchParams.set('variant',v.id); window.history.replaceState({},'',url);
      }
    }
    optionSelects.forEach(s=>s.addEventListener('change',syncVariant));

    function track(eventName, payload){
      if(typeof window.fbq==='function') window.fbq('track',eventName,payload||{});
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:eventName,...(payload||{})});
    }
    function trackProduct(eventName){
      const v=currentVariant();
      if(!v) return;
      track(eventName,{content_ids:[String(v.id)],content_type:'product',value:v.price/100,currency:'INR'});
    }

    form.addEventListener('submit',()=>trackProduct('AddToCart'));
    if(stickyAdd) stickyAdd.addEventListener('click',()=>{
      syncVariant();
      if(!stickyAdd.disabled){ trackProduct('AddToCart'); form.requestSubmit(addButton || undefined); }
    });
    if(stickyNow) stickyNow.addEventListener('click',()=>{
      syncVariant();
      if(!stickyNow.disabled){ trackProduct('InitiateCheckout'); if(buyNowButton) buyNowButton.click(); else form.requestSubmit(addButton || undefined); }
    });

    if(sticky && mainActions){
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach(entry=>sticky.classList.toggle('is-visible',!entry.isIntersecting));
      },{threshold:0.05});
      observer.observe(mainActions);
    }
    syncVariant();
  });
});
